"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.wrappedLogger = void 0;
/**
 * Okay so the purpose of these lines are to allow us to run the following code
 * in all search.client code bases:
 *
 * ```
 *   // imported directly as static module state
 *   import {logger} from "search-client-shared/services/LoggerService"
 *
 *   // works anywhere
 *   logger.info(...);
 *```
 */
exports.wrappedLogger = null;
/**
 * To support handling any logging state we are going to wrap the logger,
 * causing it to either console log, or use the logger if its been intialized
 * this could run into problems because of how state is injected in to search
 * client
 *
 * @param funcName
 */
function maybeCallWrappedFunc(funcName) {
    return function (logLine, meta) {
        try {
            if (!(exports.wrappedLogger === null || exports.wrappedLogger === void 0 ? void 0 : exports.wrappedLogger[funcName])) {
                console.error("failed to find wrapped logger! Search client is defaulting to console!");
                console.error(JSON.stringify({ logLine: logLine, meta: meta }));
            }
            else {
                exports.wrappedLogger[funcName](logLine, meta);
            }
        }
        catch (err) {
            console.error(err);
        }
    };
}
exports.logger = {
    error: maybeCallWrappedFunc("error"),
    info: maybeCallWrappedFunc("info"),
    debug: maybeCallWrappedFunc("debug"),
    warn: maybeCallWrappedFunc("warn"),
    metrics: maybeCallWrappedFunc("metrics"),
};
//# sourceMappingURL=LoggerService.js.map